import React, { useState, useEffect } from "react";
import {
  Grid,
  Paper,
  Typography,
  Button,
  TextField,
  Box,
  Fade,
  CircularProgress,
} from "@mui/material";
import PayPalCheckout from "../../header/PayPalCheckout";
import CashFreePayment from "./CashFreePayment";
import instance from "../../Axios/axiosConfig";

const prices = {
  INR: { month: 99, year: 499 },
  USD: { month: 1, year: 5 },
};

const PaymentPlans = ({ currency }) => {
  const [step, setStep] = useState(0);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [phone, setPhone] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  useEffect(() => {
    const savedName = localStorage.getItem("name") || "";
    const savedEmail = localStorage.getItem("email") != "null" ?  localStorage.getItem("email") : "";
    console.log("savedEmail",savedEmail);
    setName(savedName);
    setEmail(savedEmail);
  }, []);

  const isPhoneValid = (num) => /^\d{10}$/.test(num);
  const isEmailValid = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleContinue = (planKey) => {
    setSelectedPlan(planKey);
    setStep(1);
  };

  const handleBack = () => {
    setStep(0);
    setSelectedPlan(null);
  };

  const updatePremiumStatus = async () => {
    try {
      await instance.post("/survey/updatePremium", { email });
      await instance.post("/contact/addPremium", {
        name,
        email,
        phone,
      });
      localStorage.setItem("isPremium", true);
    } catch (err) {
      console.error("Error updating to premium", err);
    }
  };

  const renderStepIndicator = () => (
    <Box sx={{ textAlign: "center", mt: 3 }}>
      <Box sx={{ display: "inline-flex", gap: 2 }}>
        {[1, 2].map((num) => (
          <Box
            key={num}
            sx={{
              width: 32,
              height: 32,
              borderRadius: "50%",
              backgroundColor: step + 1 === num ? "#2f80ed" : "gray",
              color: "white",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: "bold",
            }}
          >
            {num}
          </Box>
        ))}
      </Box>
    </Box>
  );

  if (step === 1 && selectedPlan) {
    return (
      <Fade in={true} timeout={500}>
        <Box
          sx={{
            px: { xs: 2, sm: 4 },
            py: 4,
            maxWidth: "md",
            mx: "auto", // horizontal centering
          }}
        >
          <Typography
            variant="h5"
            textAlign="center"
            color="primary"
            gutterBottom
          >
            Complete Your Payment
          </Typography>

          <Grid
            container
            spacing={2}
            justifyContent="center"
            alignItems="center"
            sx={{ mb: 3, mt: 1 }}
          >
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                size="medium"
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="Email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                size="medium"
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="Phone Number"
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                size="medium"
              />
            </Grid>
          </Grid>

          <Grid container justifyContent="center" spacing={2}>
            <Grid item xs={12} sm={6}>
              {name && email && isPhoneValid(phone) && isEmailValid(email) && (
                <CashFreePayment
                  amount={prices.INR[selectedPlan]}
                  phoneNumber={phone}
                  onSuccess={updatePremiumStatus}
                />
              )}
              <Button
                variant="outlined"
                fullWidth
                sx={{ mt: 2 }}
                onClick={handleBack}
              >
                Back
              </Button>
            </Grid>
          </Grid>

          <Box display="flex" justifyContent="center" mt={4}>
            <Box display="flex" gap={2}>
              {[1, 2].map((num) => (
                <Box
                  key={num}
                  sx={{
                    width: 36,
                    height: 36,
                    borderRadius: "50%",
                    backgroundColor: step + 1 === num ? "#2f80ed" : "gray",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "bold",
                    fontSize: "16px",
                  }}
                >
                  {num}
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      </Fade>
    );
  }

  return (
    <Fade in={true} timeout={500}>
      <Grid container spacing={3} justifyContent="center">
        {["month", "year"].map((planKey) => (
          <Grid item xs={12} sm={6} key={planKey}>
            <Paper
              elevation={5}
              sx={{
                padding: 2,
                marginLeft: 3,
                textAlign: "center",
                borderRadius: 3,
                background:
                  planKey === "month"
                    ? "linear-gradient(135deg, #f3ec78, #af4261)"
                    : "linear-gradient(135deg, #56ccf2, #2f80ed)",
              }}
            >
              <Typography variant="h6" color="white" fontWeight="bold">
                +1 {planKey === "month" ? "Month" : "Year"}
              </Typography>
              <Typography
                variant="h4"
                sx={{ mb: 1 }}
                color="white"
                fontWeight="bold"
              >
                {currency === "INR" ? "₹" : "$"} {prices[currency][planKey]}
              </Typography>
              {currency === "INR" ? (
                <Button
                  fullWidth
                  variant="contained"
                  onClick={() => handleContinue(planKey)}
                >
                  Pay
                </Button>
              ) : (
                <PayPalCheckout Value={prices.USD[planKey]} />
              )}
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Fade>
  );
};

export default PaymentPlans;
